import './news-popup.scss'
import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {HTMLUtil} from 'yougile-util'
import {Tracking, TrackingEvent} from '@common/tracking'
import {ButtonNew} from '@components/common/base/buttons/button-new'
import {LinkButton} from '@components/common/button/button'
import {ArrowHeadRight, Comment} from '@components/common/icons/icons'
import {AvatarsStackAutoColor} from './components/avatars-stack-autocolor'
import {Modal} from './components/modal'
import {NewsPopupStore} from './news-popup-store'

const store = new NewsPopupStore()
const {state} = store

const dateDashToDot = (date: string) => (date ? date.replace(/-/g, '.') : date)

export const NewsPopup = observer(() => {
  const {newsItem} = state

  const handleClosePopup = () => {
    void Tracking.send(TrackingEvent.newsPopupClosed)
    store.close()
  }

  return newsItem ? (
    <Modal
      title={`${Lang.msg.feedback.updateFrom} ${dateDashToDot(newsItem.date)}`}
      closeByClickOutside={true}
      closeByEsc={true}
      onClose={handleClosePopup}
      footer={<Footer />}
      alwaysShowFooterSeparator
      size="medium-plus"
      useInlineSize
    >
      <h2 className="h1-global text-primary mb-20">{newsItem.title}</h2>
      <div
        className="news-popup-content-container body-long-regular text-primary"
        dangerouslySetInnerHTML={{
          __html: HTMLUtil.sanitizeHtml(newsItem.htmlContent, {
            allowedTags: ['iframe'],
            allowedAttributes: {
              iframe: [
                'width',
                'height',
                'src',
                'title',
                'frameborder',
                'allow',
                'referrerpolicy',
                'allowfullscreen'
              ],
              figure: ['class']
            }
          })
        }}
      />
    </Modal>
  ) : (
    <div />
  )
})

const SHOW_AVATARS = false

const TwFixTitle = tw.div`
  -mt-1
`

const Footer = observer(() => {
  const goToAllNews = () => {
    void Tracking.send(TrackingEvent.newsPopupClickOnButtonSeeAllNews)
    store.goToNewsItem()
  }

  const openComments = () => {
    void Tracking.send(TrackingEvent.newsPopupClickOnButtonSeeAllComments)
    store.goToNewsItem()
  }

  return (
    <div className="flex justify-between items-center">
      <ButtonNew onClick={openComments} size="md">
        {SHOW_AVATARS && (state.newsItem?.users?.length ?? 0) > 0 ? (
          <AvatarsStackAutoColor
            ids={state.newsItem?.users ?? []}
            className="mr-8"
          />
        ) : (
          <Comment />
        )}
        <div>
          <TwFixTitle>
            {state.newsItem?.messages
              ? Lang.msg.feedback.comments(state.newsItem?.messages ?? 0)
              : Lang.msg.feedback.leaveComment}
          </TwFixTitle>
        </div>
        <ArrowHeadRight className="ml-4" />
      </ButtonNew>
      <LinkButton onClick={goToAllNews}>
        {Lang.msg.feedback.allUpdates}
      </LinkButton>
    </div>
  )
})
